import fs from 'node:fs'
import path from 'node:path'
import type {
  BetterstartInstalledManifest,
  InstallableManifestStore
} from '@cli-types/core-engine/installable.js'
import { betterstartDir } from '@cli-utils/paths.js'
import { stringifyProjectJson } from '@cli-utils/shared.js'

export function createInstallableManifestStore<
  TManifest extends BetterstartInstalledManifest<string>
>(familySegment: string): InstallableManifestStore<TManifest> {
  function manifestPath(cwd: string, id: string): string {
    return path.join(betterstartDir(cwd, familySegment), id, 'manifest.json')
  }

  return {
    manifestPath,
    load(cwd, id) {
      const filePath = manifestPath(cwd, id)
      if (!fs.existsSync(filePath)) {
        return null
      }

      return JSON.parse(fs.readFileSync(filePath, 'utf-8')) as TManifest
    },
    save(cwd, manifest) {
      const filePath = manifestPath(cwd, manifest.id)
      fs.mkdirSync(path.dirname(filePath), { recursive: true })
      fs.writeFileSync(filePath, stringifyProjectJson(manifest), 'utf-8')
    },
    remove(cwd, id) {
      fs.rmSync(path.dirname(manifestPath(cwd, id)), {
        recursive: true,
        force: true
      })
    }
  }
}
